import React from "react";
import {CenterContentDiv, MyWorksWrapper} from "./MyWorksElements";
import MyWork from "./MyWork";

const MyWorks = () => {
    return <>
        <CenterContentDiv>
            <h1 id='myWorks'>My Works</h1>
        </CenterContentDiv>

        <MyWorksWrapper>
            <MyWork/>
            <MyWork/>
            <MyWork/>
            <MyWork/>
        </MyWorksWrapper>

    </>
}

export default MyWorks;
